import {
  toastPosition,
  toastTheme,
  toastType,
  toastifyProps,
} from '../../../constants/app.constants';
import { toast } from 'react-toastify';

export const showAlert = ({
  type = toastType.default,
  message = '',
  icon,
  position = toastPosition.topRight,
  theme = toastTheme.light,
}) => {
  return toast[type](message, {
    icon,
    position,
    theme,
  });
};
